import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import {  useState } from "react";
import {
  createCategory,
  createPurchaseRequest,
  deletePurchaseRequest,
  getPurchaseRequestList,
  updatePurchaseRequest,
} from "../../../../services/workspace/inventory.service";
import { useNavigate } from "react-router-dom";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import DefaultButton from "../../../components/buttons/defaultButton";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import PurchaseBasicDetails from "./components/purchaseBasicDetails";
import PurchaseDescreption from "./components/purchaseDescreption";

const actions_type = {
  DELETE: "DELETE",
  // EDIT: "EDIT",
  VIEW: "VIEW",
  // ASSIGN: "ASSIGN",
  // CLEAR: "CLEAR",
  // EXPIRE: "EXPIRE",
};

const items = [{ label: "Purchase Request", path: "" }];

const PurchaseRequest = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const navigate = useNavigate();
  const [isOpenSheet, setIsOpenSheet] = useState(false);

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getPurchaseRequestList, {
    dataPath: "purchaseReq.data",
    totalPath: "purchaseReq.meta.total",
    errorMessage: "Failed to fetch category data!",
    debounceDelay: 500,
    customParams: {
      with: "stockItems,createdBy",
    },
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Request ID", field: "code" },
      { label: "Priority", field: "priority" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "purchaseRequest",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Add data transformer function
    dataTransformer: (data) => {
      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "link",
            // onClick: () => setIsOpenSheet(true),
          },

          priority: {
            data:
              item.priority === 0
                ? "Low"
                : item.priority === 1
                ? "Medium"
                : "High",
            className: "",
            sticky: false,
            variant: "text",
          },
          expected_date: {
            data: item.expected_date,
            className: "",
            sticky: false,
            variant: "text",
          },
          name: {
            data: item.createdBy?.name,
            className: "",
            sticky: false,
            variant: "text",
          },
          createdAt: {
            data: item.created_at,
            className: "",
            sticky: false,
            variant: "date",
          },

          status: {
            data: item.status,
            className: "",
            sticky: false,
            variant: "status",
            customCases: null,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
          delete: (item) => {
            handleDelete(item.uuid.data, deletePurchaseRequest, {
              successMessage: "Purchase Request deleted successfully!",
              errorMessage: "Failed to delete purchase request!",
            });
          },
          view: (item) => {
            setIsOpenSheet(true);

            // unwrap for drawer
            const rawItem = {
              uuid: item.uuid.data,
              code: item.code.data,
              priority: item.priority.data,
              expected_date: item.expected_date.data,
              name: item.name.data,
              createdAt: item.createdAt.data,
              status: item.status.data,
              description: item?.description?.data,
              // stock_items: item?.stock_items || [],
              created_by: item?.createdBy?.name,
              stock_items: (item?.stockItems || []).map((si) => ({
                stockItems: si.stock?.name,
                quantity: si.quantity,
                detailDescreption: si.description || si.stock?.description,
              })),
            };

            setSelectedId(rawItem);
          },
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const unwrapItem = (item) => ({
  uuid: item.uuid.data,
  code: item.code.data,
  priority: item.priority.data,
  expected_date: item.expected_date.data,
  name: item.name.data,
  createdAt: item.createdAt.data,
  status: item.status.data,
  description: item?.description?.data,
  created_by: item?.createdBy?.name,
  stock_items: (item?.stockItems || []).map((si) => ({
    stockItems: si.stock?.name,
    quantity: si.quantity,
    detailDescreption: si.description || si.stock?.description,
  })),
});

  const TableHeaderData = [
    {
      label: "Request ID",
      key: "code",
    },
    {
      label: "Requested By",
      key: "name",
    },

    {
      label: "Expected Date",
      key: "expected_date",
    },
    {
      label: "Created At",
      key: "createdAt",
    },
    {
      label: "Priority",
      key: "priority",
    },
    {
      label: "Status",
      key: "status",
    },
  ];

  const DetailHeaderData = [
    { label: "Items", key: "stockItems" },
    { label: "Quantity", key: "quantity" },
    { label: "Description", key: "detailDescreption" },
  ];

  // Comprehensive form fields
  const comprehensive = [
    // Basic text fields
    {
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter category name",
      required: true,
      minLength: 2,
      maxLength: 40,
    },

    // Textarea
    {
      name: "description",
      label: "Description",
      type: "textarea",
      required: true,
      placeholder: "Write description here...",
      maxLength: 300,
    },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (isSubCategoryModalOpen) {
        const payload = {
          ...values,
          parent_id: selectedId?.id?.data,
        };

        await handleCreate(payload, createPurchaseRequest, {
          successMessage: "Stock created successfully!",
          errorMessage: "Failed to create stock!",
        });
      } else if (isEditValue) {
        await handleUpdate(values, isEditValue.uuid, updatePurchaseRequest, {
          successMessage: "Stock updated successfully!",
          errorMessage: "Failed to update stock!",
        });
      } else {
        await handleCreate(values, createCategory, {
          successMessage: "stock created successfully!",
          errorMessage: "Failed to create stock!",
        });
      }
    } finally {
      setSubmitting(false);
      setTimeout(() => {
        resetForm();
      }, 2000);
    }
  };

  const handleCancel = () => {
  };

  const onClose = (reload = false) => {
    setSelectedId("");
    setIsSubCategoryModalOpen(false);
    if (reload === true) {
      fetchData();
    }
  };

  const convertToPurchaseOrder = () => {
  navigate(`/inventory/purchase-order/add/${selectedId?.uuid}`, {
    state: { purchaseRequest: selectedId },
  });
};

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() =>
          navigate("/inventory/purchase-request/add", actions_type.ADD)
        }
        shorting
        sortingModule="purchaseRequest"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />
        <BottomDrawer
          size={"md"}
          title="Purchase Request"
          isOpen={isOpenSheet}
          setIsOpen={setIsOpenSheet}
        >
          {selectedId?.status === 0 && (
            <div className={"items-end"}>
              <DefaultButton
                icon={<LiaFileInvoiceSolid />}
                name={"Convert to Purchase Order"}
                onClick={() => convertToPurchaseOrder()}
              />
            </div>
          )}
          <div className=" py-2 flex flex-col gap-4">
            <PurchaseBasicDetails item={selectedId} />
            <CommonTable
              TableHeaderData={DetailHeaderData}
              tabledata={selectedId?.stock_items}
              // currentPage={currentPage}
              // totalData={totalData}
              setCurrentPage={handlePageChange}
              loading={loading}
            />
          </div>
        </BottomDrawer>
      </div>
    </div>
  );
};
export default PurchaseRequest;
